var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentProviderError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285,
    height: 163.673,
    viewBox: "0 0 285 163.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c9cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c8d2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6c8d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c9cd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c9cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.198,
    y1: 1.03,
    x2: 0.802,
    y2: -0.03,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#062c5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#12416d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#3479a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#499cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#51a9ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55bcb8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2878",
    "data-name": "Group 2878",
    transform: "translate(-45 -166.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2877",
    "data-name": "Group 2877",
    transform: "translate(95 166.327)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    width: 9.65,
    height: 1.135,
    transform: "translate(17.363 3.25)",
    opacity: 0.49,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018",
    "data-name": "Rectangle 2018",
    width: 9.65,
    height: 1.135,
    transform: "translate(17.363 9.21)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2014",
    "data-name": "Rectangle 2014",
    width: 23.842,
    height: 1.135,
    transform: "translate(3.171 16.996)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2017",
    "data-name": "Rectangle 2017",
    width: 23.842,
    height: 1.135,
    transform: "translate(3.171 11.197)",
    opacity: 0.7,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2012",
    "data-name": "Rectangle 2012",
    width: 7.096,
    height: 1.135,
    transform: "translate(19.918 5.237)",
    opacity: 0.49,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2013",
    "data-name": "Rectangle 2013",
    width: 10.805,
    height: 0.982,
    transform: "translate(16.209 18.978)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2016",
    "data-name": "Rectangle 2016",
    width: 7.096,
    height: 1.135,
    transform: "translate(19.918 13.184)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(26.58 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_97",
    "data-name": "Union 97",
    transform: "translate(0 0)",
    fill: "#ebebed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33.69436264038086 24.01245498657227 L 2.000001430511475 24.01245498657227 C 1.172901272773743 24.01245498657227 0.5000013113021851 23.33955574035645 0.5000013113021851 22.51245498657227 L 0.5000013113021851 1.999995589256287 C 0.5000013113021851 1.172895550727844 1.172901272773743 0.5000056028366089 2.000001430511475 0.5000056028366089 L 33.69436264038086 0.5000056028366089 C 34.52146148681641 0.5000056028366089 35.19436264038086 1.172895550727844 35.19436264038086 1.999995589256287 L 35.19436264038086 22.51245498657227 C 35.19436264038086 23.33955574035645 34.52146148681641 24.01245498657227 33.69436264038086 24.01245498657227 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 0.9999961853027344 C 1.448600769042969 0.9999961853027344 1 1.44859504699707 1 1.999996185302734 L 1 22.51245498657227 C 1 23.06385612487793 1.448600769042969 23.5124454498291 2 23.5124454498291 L 33.69436264038086 23.5124454498291 C 34.24576187133789 23.5124454498291 34.69436264038086 23.06385612487793 34.69436264038086 22.51245498657227 L 34.69436264038086 1.999996185302734 C 34.69436264038086 1.44859504699707 34.24576187133789 0.9999961853027344 33.69436264038086 0.9999961853027344 L 2 0.9999961853027344 M 2 -3.814697265625e-06 L 33.69436264038086 -3.814697265625e-06 C 34.79893112182617 -3.814697265625e-06 35.69436264038086 0.8954257965087891 35.69436264038086 1.999996185302734 L 35.69436264038086 22.51245498657227 C 35.69436264038086 23.61702537536621 34.79893112182617 24.5124454498291 33.69436264038086 24.5124454498291 L 2 24.5124454498291 C 0.8954315185546875 24.5124454498291 0 23.61702537536621 0 22.51245498657227 L 0 1.999996185302734 C 0 0.8954257965087891 0.8954315185546875 -3.814697265625e-06 2 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#c8c9cd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1903",
    "data-name": "Rectangle 1903",
    width: 35.112,
    height: 5.836,
    transform: "translate(0.291 5.222)",
    fill: "#c8c9cd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1904",
    "data-name": "Rectangle 1904",
    width: 17.909,
    height: 2.396,
    rx: 1.198,
    transform: "translate(2.872 15.113)",
    fill: "#c8c9cd"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 142.5,
    cy: 41,
    rx: 142.5,
    ry: 41,
    transform: "translate(45 248)",
    fill: "#ebebed",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 85.5,
    cy: 19,
    rx: 85.5,
    ry: 19,
    transform: "translate(102 265)",
    fill: "#ebebed",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2876",
    "data-name": "Group 2876",
    transform: "translate(108.171 178.583)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010-2",
    "data-name": "Rectangle 2010",
    width: 28.904,
    height: 3.4,
    transform: "translate(52.004 15.683)",
    opacity: 0.5,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018-2",
    "data-name": "Rectangle 2018",
    width: 28.904,
    height: 3.4,
    transform: "translate(52.004 27.585)",
    opacity: 0.5,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2011",
    "data-name": "Rectangle 2011",
    width: 80.907,
    height: 3.4,
    transform: "translate(0 21.633)",
    opacity: 0.5,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2014-2",
    "data-name": "Rectangle 2014",
    width: 71.409,
    height: 3.4,
    transform: "translate(9.498 52.889)",
    opacity: 0.5,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2017-2",
    "data-name": "Rectangle 2017",
    width: 71.409,
    height: 3.4,
    transform: "translate(9.498 33.536)",
    opacity: 0.5,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2013-2",
    "data-name": "Rectangle 2013",
    width: 32.361,
    height: 2.942,
    transform: "translate(48.546 58.823)",
    opacity: 0.5,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2016-2",
    "data-name": "Rectangle 2016",
    width: 21.253,
    height: 3.4,
    transform: "translate(59.654 39.488)",
    opacity: 0.5,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_347-2",
    "data-name": "Group 347",
    transform: "translate(79.608 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345-2",
    "data-name": "Group 345",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_97-2",
    "data-name": "Union 97",
    transform: "translate(0 0)",
    fill: "#ebebed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 100.9061965942383 72.41587829589844 L 6.000008583068848 72.41587829589844 C 3.242994546890259 72.41587829589844 1.000008821487427 70.17289733886719 1.000008821487427 67.41587829589844 L 1.000008821487427 5.999996185302734 C 1.000008821487427 3.242981910705566 3.242994546890259 0.9999963045120239 6.000008583068848 0.9999963045120239 L 100.9061965942383 0.9999963045120239 C 103.6632080078125 0.9999963045120239 105.9061965942383 3.242981910705566 105.9061965942383 5.999996185302734 L 105.9061965942383 67.41587829589844 C 105.9061965942383 70.17289733886719 103.6632080078125 72.41587829589844 100.9061965942383 72.41587829589844 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 2 C 3.794403076171875 2 2 3.794403076171875 2 6 L 2 67.41587829589844 C 2 69.62147521972656 3.794403076171875 71.41587829589844 6 71.41587829589844 L 100.9061889648438 71.41587829589844 C 103.1117858886719 71.41587829589844 104.9061889648438 69.62147521972656 104.9061889648438 67.41587829589844 L 104.9061889648438 6 C 104.9061889648438 3.794403076171875 103.1117858886719 2 100.9061889648438 2 L 6 2 M 6 0 L 100.9061889648438 0 C 104.2198944091797 0 106.9061889648438 2.686294555664062 106.9061889648438 6 L 106.9061889648438 67.41587829589844 C 106.9061889648438 70.72958374023438 104.2198944091797 73.41587829589844 100.9061889648438 73.41587829589844 L 6 73.41587829589844 C 2.686294555664062 73.41587829589844 0 70.72958374023438 0 67.41587829589844 L 0 6 C 0 2.686294555664062 2.686294555664062 0 6 0 Z",
    stroke: "none",
    fill: "#c8c9cd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1903-2",
    "data-name": "Rectangle 1903",
    width: 105.161,
    height: 17.48,
    transform: "translate(0.873 15.64)",
    fill: "#c8c9cd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1904-2",
    "data-name": "Rectangle 1904",
    width: 53.64,
    height: 7.176,
    rx: 3.588,
    transform: "translate(8.601 45.265)",
    fill: "#c8c9cd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(152.928 195.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_101",
    "data-name": "Union 101",
    d: "M34.572,62.677H10.434a10.432,10.432,0,0,1-9.04-15.642L25.532,5.226a10.432,10.432,0,0,1,18.08,0L67.75,47.034a10.433,10.433,0,0,1-9.04,15.642Z",
    transform: "translate(0 23.945)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_100",
    "data-name": "Union 100",
    d: "M51.222,54.33H6.261A6.259,6.259,0,0,1,.835,44.948L24.972,3.14A6.287,6.287,0,0,1,30.4,0c.06,0,.12,0,.18,0A6.282,6.282,0,0,1,35.824,3.14L59.962,44.948a6.259,6.259,0,0,1-5.426,9.382Z",
    transform: "translate(4.174 28.118)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_102",
    "data-name": "Union 102",
    d: "M0,33.389a3.478,3.478,0,1,1,3.487,3.478H3.478A3.478,3.478,0,0,1,0,33.389ZM0,22.26V3.478a3.478,3.478,0,1,1,6.956,0V22.26A3.478,3.478,0,0,1,0,22.26Z",
    transform: "translate(31.094 38.625)",
    fill: "#4a4a4a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "helion-logo",
    "data-name": "Path 3450",
    d: "M21.783,16.249V23.2H4.332A4.332,4.332,0,0,1,0,18.869V1.689H7.467v14.56Zm0-10.2a4.356,4.356,0,0,0-4.356-4.356H10.5v11.99H21.782Z",
    transform: "translate(212 55.67)",
    fill: "url(#linear-gradient-9)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentProviderError);
export default __webpack_public_path__ + "static/media/PaymentProviderError.2305190c8d9819a3e08f35ed9b95a5be.svg";
export { ForwardRef as ReactComponent };